<script setup lang="tsx">
import { ref, onBeforeMount, computed } from 'vue'
import http from '@/services/http'
import type { Response } from '@/models/api-generated'
import { ConditionallyImplemented, Implemented, Older, PermAllMeasureRead, PermOwnMeasureRead } from '@/models/enums-generated'
import { useI18n } from 'vue-i18n'
import toastStore from '@/stores/toast'
import { hasPermission } from '@/services/utils'

const i18n = useI18n()
const toaster = toastStore()
const userId = computed(() => sessionMap.user.id)
const smmdIds = ref<number[]>()
const DAYS_AFTER_LAST_REVIEW = 300
const canViewMethods = computed(() => hasPermission(PermOwnMeasureRead, PermAllMeasureRead))
const roles = sessionMap.user.roles

onBeforeMount(async () => {
	if (!canViewMethods.value) {
		smmdIds.value = []
		return
	}
	const { data } = await http.get<Response<number[]>>('api/dashboard/reviewMethods')
	smmdIds.value = data.data
})

function goToMethodsPage() {
	const responsible = JSON.stringify({ id: userId.value, type: 'users' })
	const paramsObj = { responsible }
	const params = new URLSearchParams(paramsObj)

	roles.forEach((role) => {
		const roleResponsible = JSON.stringify({ id: role.id, type: 'roles' })
		params.append('responsible', roleResponsible)
	})

	params.append('status', ConditionallyImplemented)
	params.append('status', Implemented)
	params.append('updatedAt', Older)

	const date = new Date()
	date.setDate(date.getDate() - DAYS_AFTER_LAST_REVIEW)
	params.append('updatedAt', date.toISOString().split('T')[0])

	window.location.href = `/app/methods?${params}`
}

async function confirmReview() {
	const { data } = await http.post<Response<any>>('api/applicableMethods/updateReviewDate', { methodIds: smmdIds.value })

	if (data.status === 'OK') {
		toaster.showSuccess(i18n.t('review.methodsReviewed', { count: smmdIds.value?.length }))
		smmdIds.value = []
	}
}
</script>

<template>
	<div v-if="smmdIds && smmdIds.length > 0" class="d-flex justify-content-center my-3">
		<div class="alert alert-info text-center shadow-sm p-3" role="alert">
			<p class="mb-3">
				{{ $t('review.reviewMethodsInfo', { count: smmdIds.length }) }}
			</p>
			<div class="d-flex justify-content-around">
				<button @click="goToMethodsPage" class="btn btn-primary">
					{{ $t('review.viewMethods') }}
				</button>
				<button @click="confirmReview" class="btn btn-primary">
					{{ $t('misc.confirm') }}
				</button>
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.alert
	max-width: 500px
</style>
